import React, { Component } from 'react';
import { Link } from 'react-router-dom';

import classNames from 'classnames';
import { Dropdown } from 'components/dropdown';
import { I18n } from 'components/translate';
import { ROUTES } from 'configs/routes/constants';
import { inject, observer, PropTypes as MobxPropTypes } from 'mobx-react';
import {
  EVENT_ACTIONS,
  EVENTS_INTERACTIONS,
  EVENTS_CATEGORY,
  EVENTS_LABELS
} from 'modules/app/services/datahub/constants';
import DatahubService from 'modules/app/services/datahub/DatahubService';
import { buildInteractionEventData } from 'modules/app/services/datahub/helper';
import NotificationService from 'modules/notification/NotificationService';
import PropTypes from 'prop-types';

import NotificationEvents from '../../events';
import { NotificationList } from '../notificationList';

import './Widget.scss';

@inject('NotificationStore')
@observer
export default class Widget extends Component {
  static propTypes = {
    NotificationStore: MobxPropTypes.objectOrObservableObject,
    onClick: PropTypes.func
  };

  componentDidMount() {
    NotificationService.init();
  }

  get header() {
    return (
      <div className="notification__widget__header">
        <I18n label="notification.title" />
      </div>
    );
  }

  onShowAll = () => {
    NotificationEvents.sendClick({ label: 'ShowAll' });

    DatahubService.sendEvent({
      action: EVENT_ACTIONS.INTERACT,
      event: buildInteractionEventData({
        category: EVENTS_CATEGORY.HORIZONTAL_MENU.NOTIFICATIONS_HORIZONTAL_MENU,
        label: EVENTS_LABELS.HORIZONTAL_MENU.SHOW_ALL,
        action: EVENTS_INTERACTIONS.CLICK
      })
    });
  };

  setReceived = () => {
    const { onClick, NotificationStore } = this.props;
    const { unreadNotifications } = NotificationStore;

    onClick && onClick();
    NotificationService.setItemsReceived(unreadNotifications);
  };

  render() {
    const { unreadNotificationsAmount, notifications } =
      this.props.NotificationStore;
    const icon = (
      <i className="icon icon-bell" data-amount={unreadNotificationsAmount} />
    );
    const classComponent = classNames('notification__widget', {
      'notification__widget--unread': unreadNotificationsAmount !== 0
    });

    return (
      <Dropdown
        className={classComponent}
        classNameMenu="notification__dropdown"
        dropdownMenuMaxHeight={null}
        dropdownToggle={icon}
        onClick={this.setReceived}
      >
        {this.header}
        <NotificationList items={notifications} />
        <Link
          to={ROUTES.COMMUNITY.LIST}
          className="notification__widget__show__all"
          onClick={this.onShowAll}
        >
          <I18n label="notification.show_all" />
        </Link>
      </Dropdown>
    );
  }
}
